import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'src/app/interfaces/message';
import { MessageService } from 'src/app/services/api/message.service';
import { ErrorService } from 'src/app/services/error.service';
import { SecurityService } from 'src/app/services/security.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-open-message-url',
    templateUrl: './open-message-url.component.html',
    styleUrls: ['./open-message-url.component.scss']
})

export class OpenMessageUrlComponent implements OnInit {
    
    public ref: string | undefined;
    public message: Message | undefined;
  
    public errorMessage: string ;
    public errorType: string ;

    constructor(public userService: UserService, 
                public route: Router, 
                private errorService: ErrorService,
                public activeRoute: ActivatedRoute,
                public messageApi: MessageService) 
    { 
        this.errorMessage = "";
        this.errorType = "";
    }

    ngOnInit(): void {

        this.activeRoute.params.subscribe(params => {
            if (params.ref) {
                this.ref = encodeURIComponent(params.ref);
            }
        });

        if (this.userService.currentUser.apiToken) {
            this.messageApi.open(this.ref!).subscribe((res) => {
                if (res.result == "SUCCESS") {
                    this.message = res.content;
                } else {
                    this.errorType = res.result;
                    this.errorMessage = res.content;
                }
            });
        } else {
            this.errorService.errorType = "ERROR";
            this.errorService.errorMessage = "Not connected";
            this.route.navigate(['/error']);
        }
    }
}
